import { privateFetch } from "api/privateFetch";

/**
 * Get Free Slots
 * @param {{csmId: string; params: Object}} Payload CSM ID & Params
 * @returns {Promise<Object[]>} Response
 */
const freeSlots = async ({ csmId, params }) => {
  const { data } = await privateFetch.get(`csm/${csmId}/freeslots`, {
    params,
  });
  return data;
};

export default freeSlots;
